import React from "react";
const CreateAccountIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
    <path
      opacity="0.12"
      d="M9.70964 12.0423C12.4941 12.0423 14.7513 9.78509 14.7513 7.00065C14.7513 4.21622 12.4941 1.95898 9.70964 1.95898C6.9252 1.95898 4.66797 4.21622 4.66797 7.00065C4.66797 9.78509 6.9252 12.0423 9.70964 12.0423Z"
      fill="#6941C6"
    />
    <path
      d="M12 16.6002H7.05C5.51488 16.6002 4.74732 16.6002 4.12274 16.8019C2.7165 17.2562 1.61604 18.4279 1.18946 19.9253C1 20.5904 1 21.4077 1 23.0423M19.7 23.0423V16.0145M16.4 19.5284H23M14.75 7.22982C14.75 10.1408 12.5338 12.5006 9.8 12.5006C7.06619 12.5006 4.85 10.1408 4.85 7.22982C4.85 4.31882 7.06619 1.95898 9.8 1.95898C12.5338 1.95898 14.75 4.31882 14.75 7.22982Z"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default CreateAccountIcon;
